import { useLazyQuery, useMutation } from "@apollo/client";
import { DEPLOY } from "@store/operations/customOperations";

export const useDeploy = () => useMutation(DEPLOY);
